// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2s8Q-","empty":"ModalGraph_empty__3KofE"};